import { render, staticRenderFns } from "./ComponentServiceZone.vue?vue&type=template&id=6ff7807b&"
import script from "./ComponentServiceZone.vue?vue&type=script&lang=ts&"
export * from "./ComponentServiceZone.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentServiceZone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
